<template>
  <section id="pinContainer">
    <!-- LANDING PAGE -->
    <div id="intro" class="panel landing" v-if="$store.state.currentLocation >= 0">
      <div id="intro-parallax" class="panel__parallax panel__parallax--intro" style=""></div>
      <img src="@/assets/img/_branding/ccsa-logo-fr.svg" width="400px" alt="ccsa logo" class="landing__logo">
      <h1 class="landing__h1">Je mets fin à la stigmatisation{{'\xa0'}}: </h1>
      <h2 class="landing__h2">recentrer la conversation sur l’usage de substances</h2>
      <button
        class="btn-nav btn-nav--normal"
        :loc="0.5"
        @click="$store.dispatch('showNext', { n: 0.5, el: '#sb-1-00' })"
      >
        Commencer
      </button>
      <img src="@/assets/img/_ui/down-chevron.svg" width="40px" alt="" class="landing__arrow mt-4">
    </div>

    <!-- 1-00 -->
    <div id="sb-1-00" class="panel bg-blue full-height" v-if="$store.state.currentLocation >= 0.5">
      <div id="" class="panel__parallax panel__parallax--blue-bg" style=""></div>
      <content-block class="content-block--full-height">
        <p id="sb-1-00 p" class="text-center">Les mots que nous utilisons pour parler de l’usage de substances sont importants. Ils sont souvent blessants et inexacts.</p>
        <button-sequenced
          class="btn-nav--white"
          :loc="1"
          link="sb-1-01"
        >
          Go on
        </button-sequenced>
      </content-block>
    </div>

    <!-- 1-01 -->
    <div id="sb-1-01" class="panel panel--wipe full-height" v-if="$store.state.currentLocation >= 1">
      <div id="" class="panel__parallax panel__parallax--chevron-bg" style=""></div>
      <content-block id="animate2" class="content-block--full-height">
        <p id="sb-1-01-p1"><em>«{{'\xa0'}}L’<strong>abus de substances</strong> affecte des Canadiens de tous horizons.{{'\xa0'}}» </em></p>
        <p id="sb-1-01-p2"><em>«{{'\xa0'}}Elle est <strong>propre</strong> depuis presque un an.{{'\xa0'}}»</em></p>
        <p id="sb-1-01-p3"><em>«{{'\xa0'}}Il va probablement <strong>faire une rechute</strong>.{{'\xa0'}}»</em></p>
        <p id="sb-1-01-p4"><em>«{{'\xa0'}}Je vois beaucoup de <strong>buveurs compulsifs</strong> depuis quelque temps.{{'\xa0'}}»</em></p>
        <p id="sb-1-01-p5"><em>«{{'\xa0'}}La <strong>dépendance</strong> aux opioïdes est une condamnation à mort pour beaucoup.{{'\xa0'}}»</em></p>
        <button-sequenced
          class="btn-nav--blue"
          :loc="2"
          link="sb-1-02"
        >
          Continue
        </button-sequenced>
      </content-block>
    </div>

    <!-- 1-02 -->
    <div id="sb-1-02" class="panel bg-blue full-height" v-if="$store.state.currentLocation >= 2">
      <div id="" class="panel__parallax panel__parallax--blue-bg" style=""></div>
      <content-block class="content-block--full-height">
        <p id="">Quand avez-vous parlé d’une personne qui consomme pour la dernière fois?</p>
        <p id="">Vous rappelez-vous ce que vous avez dit?</p>
        <button-sequenced
          class="btn-nav--white"
          :loc="3"
          link="sb-1-03"
        >
          Go on
        </button-sequenced>
      </content-block>
    </div>

    <!-- 1-03 -->
    <div id="sb-1-03" class="panel full-height" v-if="$store.state.currentLocation >=3">
      <!-- <div id="" class="panel__parallax panel__parallax--blue-bg" style=""></div> -->
      <content-block class="content-block--full-height">
        <p class="text-center" id="sb-1-03-p1" style="font-family:rockwell"><span style="font-size: 3rem;">Le coût humain de l’usage de substances est <strong class="text-purple-2">effarant{{'\xa0'}}:</strong></span></p>
        <img src="@/assets/img/3-03a.svg" alt="" id="sb-1-03-img-01" class="content-block__img img-fluid">
        <p class="text-center" id="sb-1-03-p2" style="font-family:rockwell"><span style="font-size: 3rem;">Chaque année, <strong class="text-purple-2">3,3 millions </strong> de personnes meurent des suites d’une consommation nocive d’alcool</span></p>
        <p class="text-center" id="sb-1-03-p2" style="font-family:rockwell"><span style="font-size: 3rem;"><strong class="text-purple-2">350 000</strong> personnes meurent d’un trouble lié à l’usage d’alcool ou de drogue illicite</span></p>
        <div id="sb-1-04-l1" class="divider-line divider-line--blue"></div>
        <img src="@/assets/img/3-03b.svg" alt="" id="sb-1-03-img-02" class="content-block__img img-fluid">
        <p class="text-center" id="sb-1-03-p3" style="font-family:rockwell"><span style="font-size: 3rem;">Pourtant, <strong class="text-blue">seuls 14 % </strong> des personnes qui répondent aux critères du trouble lié à l’usage de substances reçoivent une forme quelconque de traitement.</span></p>
        <button-sequenced
          class="btn-nav--white-2"
          :loc="4"
          link="sb-1-04"
        >
          Understood
        </button-sequenced>
      </content-block>
    </div>

    <!-- 1-04 -->
    <div id="sb-1-04" class="panel bg-light-pink d-flex align-items-center justify-content-center full-height" v-if="$store.state.currentLocation >= 4">
      <!-- <div id="" class="panel__parallax panel__parallax--chevron-bg" style=""></div> -->
      <content-block class="">
        <div class="row">
          <div class="col-3">
            <img src="@/assets/img/_ui/group-chevron.svg" alt="" class="content-block__img img-fluid" id="sb-1-04-image">
          </div>
          <div class="col">
            <p>Des études ont montré que la <strong class="text-purple">stigmatisation</strong> est l’un des plus grands obstacles à la recherche et à l’obtention d’un traitement.</p>
            <p>La stigmatisation prend souvent la forme de <strong class="text-purple">termes désobligeants</strong> qui humilient et rabaissent les gens.</p>
            <p>De tels termes déclenchent parfois un cycle de comportements et d’attitudes qui <strong class="text-purple">isolent et marginalisent</strong> les personnes qui consomment.</p>
            <button-sequenced
              class="btn-nav--blue"
              :loc="5"
              link="sb-1-05"
            >
              Continue
            </button-sequenced>
          </div>
        </div>
      </content-block>
    </div>

    <!-- 1-05 -->
    <div id="sb-1-05" class="panel panel__parallax--chevron-bg d-flex align-items-center justify-content-center" v-if="$store.state.currentLocation >= 5">
      <!-- <div id="" class="panel__parallax panel__parallax--chevron-bg" style=""></div> -->
      <content-block class="">
        <div class="row">
          <div class="col-3">
            <img src="@/assets/img/_ui/group-chevron.svg" alt="" class="content-block__img img-fluid">
          </div>
          <div class="col">
            <p>Les <strong class="text-purple">termes que nous utilisons</strong> en tant que société pour décrire les gens et leurs problèmes de santé influencent et reflètent nos attitudes et nos façons de les aider.</p>
            <p>La langue évolue et <strong class="text-purple">s’adapte continuellement pour réagir </strong> à l’évolution des valeurs sociales et à la façon dont notre culture comprend l’oppression.</p>
            <p>Certains mots tombent graduellement en désuétude; d’autres doivent être consciemment et <strong class="text-purple">volontairement éliminés </strong> du vocabulaire lorsqu’on se rend compte qu’ils sont <strong class="text-purple">inexacts ou désobligeants</strong>.</p>
            <button-sequenced
              class="btn-nav--blue"
              :loc="6"
              link="sb-1-06"
            >
              Continue
            </button-sequenced>
          </div>
        </div>
      </content-block>
    </div>

    <!-- 1-06 -->

    <div id="sb-1-06" class="panel full-height" v-if="$store.state.currentLocation >= 6">
      <!-- <div id="" class="panel__parallax panel__parallax--blue-bg" style=""></div> -->
      <content-block class="content-block--full-height">
        <p>Les <strong class="text-purple">expressions et la terminologie</strong> relatives au trouble lié à l’usage d’alcool et de drogue <strong class="text-purple">ont changé </strong> et continuent à évoluer au fur et à mesure que nous apprenons à le connaître.</p>
        <div class="accordion-group accordion-group--pink mb-0" >
          <accordion-icon headerText="Plutôt que de dire ceci…  ">
            <p>Toxicomanie</p>
          </accordion-icon>
        </div>
        <div class="accordion-group accordion-group--blue mt-0">
          <accordion-icon headerText="Dire cela…">
            <p>Trouble lié à l’usage de substances</p>
          </accordion-icon>
        </div>
        <div class="accordion-group accordion-group--pink mb-0">
          <accordion-icon headerText="Plutôt que de dire ceci… ">
            <p>Surdose</p>
          </accordion-icon>
        </div>
        <div class="accordion-group accordion-group--blue mt-0">
          <accordion-icon headerText="Dire cela…">
            <p>Intoxication à la drogue</p>
          </accordion-icon>
        </div>
        <div class="accordion-group accordion-group--pink mb-0">
          <accordion-icon headerText="Plutôt que de dire ceci… ">
            <p>Propre ou sobre </p>
          </accordion-icon>
        </div>
        <div class="accordion-group accordion-group--blue mt-0">
          <accordion-icon headerText="Dire cela…">
            <p>En rétablissement ou sans drogue</p>
          </accordion-icon>
        </div>
        <div class="accordion-group accordion-group--pink mb-0">
          <accordion-icon headerText="Plutôt que de dire ceci… ">
            <p>Rechute</p>
          </accordion-icon>
        </div>
        <div class="accordion-group accordion-group--blue mt-0">
          <accordion-icon headerText="Dire cela…">
            <p>Récurrence ou reprise de l’usage</p>
          </accordion-icon>
        </div>
        <button-sequenced
          class="btn-nav--white-2"
          :loc="7"
          link="sb-1-07"
        >
          Understood
        </button-sequenced>
      </content-block>
    </div>
    <!-- 1-07 -->
    <div id="sb-1-07" class="panel bg-blue full-height" v-if="$store.state.currentLocation >= 7">
      <div id="" class="panel__parallax panel__parallax--blue-bg" style=""></div>
      <content-block class="content-block--full-height">
        <p>Formulez une phrase à propos d’une personne que vous connaissez ayant une expérience vécue de l’usage de substances. Remplacez maintenant le mot <em>toxicomanie</em> par <strong>trouble lié à l’usage de substances</strong> dans cette phrase. </p>
        <button-sequenced
          class="btn-nav--white"
          :loc="8"
          link="sb-1-08"
        >
          Understood
        </button-sequenced>
      </content-block>
    </div>

    <!-- 1-08 -->
    <div id="sb-1-08" class="panel bg-light-pink  d-flex align-items-center justify-content-center full-height" v-if="$store.state.currentLocation >= 8">
      <!-- <div id="" class="panel__parallax panel__parallax--chevron-bg" style=""></div> -->
      <content-block class="">
        <div class="row">
          <div class="col-3">
            <img src="@/assets/img/_ui/group-chevron.svg" alt="" class="content-block__img img-fluid" id="sb-1-08-image">
          </div>
          <div class="col">
            <p id="sb-1-08-p1">Vous trouvez peut-être que <em>toxicomanie</em> n’est pas offensant. Pourquoi faudrait-il le remplacer par  <strong class="text-purple">trouble lié à l’usage de substances</strong>?</p>
            <p id="sb-1-08-p2">Parce que selon des études, certains termes modifient nos attitudes ou croyances inconscientes et influent sur notre compréhension, nos gestes et nos décisions (<strong class="text-purple">biais cognitifs implicites</strong>).</p>
            <!-- <ul id="sb-1-08-li">
              <li>Consider: The patient has an addiction to opioids.</li>
              <li>Versus: Addiction is a curse on society. </li>
            </ul>
            <p id="sb-1-08-p3">The same term, used in different contexts, becomes tainted with negative connotations and stereotypes. </p>
            <p><sup id="sb-1-08-p4" class="text-purple">* The unconscious attitudes or beliefs that we hold about a social group that affect our understanding, actions and decisions.</sup></p> -->
            <button-sequenced
              class="btn-nav--blue"
              :loc="9"
              link="sb-1-09"
            >
              Continue
            </button-sequenced>
          </div>
        </div>
      </content-block>
    </div>

    <!-- 1-09 -->
    <div id="sb-1-09" class="panel bg-blue full-height" v-if="$store.state.currentLocation >= 9">
      <div id="" class="panel__parallax panel__parallax--blue-bg" style=""></div>
      <content-block class="content-block--full-height">
        <p>Connaissez-vous d’autres termes liés à l’usage de substances qui <em>semblent</em> neutres, mais qui ont pris une connotation négative avec le temps?</p>
        <button-sequenced
          class="btn-nav--white"
          :loc="9.5"
          link="sb-1-09a"
        >
          Understood
        </button-sequenced>
      </content-block>
    </div>

    <!-- 1-10 -->
    <div id="sb-1-09a" class="panel panel__parallax--chevron-bg" v-if="$store.state.currentLocation >= 9.5">
      <!-- <div id="" class="panel__parallax panel__parallax--chevron-bg" style=""></div> -->
      <content-block class="">
        <p class="text-purple jumbo-text">Les mots sont importants, ACEPA Canada </p>
        <!-- <p>Gord Garner, Executive Director, Community Addictions Peer Support Association</p> -->
        <div class="">
          <!-- <iframe width="100%" height="520px" src="https://www.youtube.com/embed/lSUTq8KLaN0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
          <!-- poster="@/assets/img/_poster/1-08a.png" -->
          <video
            src="@/assets/video/3-09a.mp4"
            poster="@/assets/img/_poster/3-09a.jpg"
            @ended="replayVideo($event)"
            controls controlsList="nodownload"
            class="img-fluid"
          >
            <track label="Francais" kind="subtitles" srclang="fr" :src="`${publicPath}cc/3-09a.fr-ca.vtt`" default>
          </video>
        </div>
        <div class="accordion-group accordion-group--pink">
          <accordion-icon headerText="Transcription">
            <p>#LangageAxéSurLaPersonne</p>
            <p>#JeMetsFinÀLaStigmatisation</p>
            <p>#ChangerLesMentalités</p>
            <p>#LesMotsComptent</p>
            <p>Et si nous parlions de la stigmatisation et du langage axé sur la personne? Jouons cartes sur table…</p>
            <p>[Accro, stigmatisation, cheminement, aide, sain, bien-être, personne, guérison, optimiste, individu, équité, espoir] </p>
            <p>Les mots que nous lisons, écrivons, entendons et prononçons comptent. Ils façonnement nos idées, comportements, politiques. Les mots changent les directions, les avis et les issues. Utilisez des mots qui mettent en valeur et non qui rabaissent. Utilisez des mots qui amenuisent la peur et qui gomment la stigmatisation.</p>
            <p>Utilisez des mots qui permettent la guérison au lieu de blesser.</p>
            <p>Quand vous dites alternative, j’ai de l’espoir.</p>
            <p>Quand vous dites bien-être, je vois un chemin.</p>
            <p>Certains mots n’aident pas [drogué, alcolo, sale, crack, accro, camé, propre, toxicomane, abuseur de drogues, fou]</p>
            <p>Quand vous dites drogué, j’entends paumé. </p>
            <p>Quand vous dites propre, je me sens sale, blessé.</p>
            <p>Guérison, santé</p>
            <p>#LangageAxéSurLaPersonne</p>
            <p>#JeMetsFinÀLaStigmatisation</p>
            <p>#ChangerLesMentalités</p>
            <p>#LesMotsComptent</p>
          </accordion-icon>
        </div>
        <button-sequenced
          class="btn-nav--blue"
          :loc="10"
          link="sb-1-10"
        >
          Continue
        </button-sequenced>
      </content-block>
    </div>

    <!-- 1-10 -->
    <div id="sb-1-10" class="panel bg-light-blue-2 full-height d-flex align-items-center justify-content-center" v-if="$store.state.currentLocation >= 10">
      <!-- <div id="" class="panel__parallax panel__parallax--chevron-bg" style=""></div> -->
      <content-block>
        <p d="sb-1-10-p1" class="text-center"> <strong-2>Les mots que nous utilisons peuvent influencer nos opinions et nos actions… et sauver des vies.</strong-2></p>
        <div class="row">
          <div class="col-3 my-auto">
            <img src="@/assets/img/_ui/group-chevron.svg" alt="" class="content-block__img img-fluid" id="sb-1-10-image">
          </div>
          <div class="col my-auto">
            <p id="sb-1-10-p2">Prenons comme exemple un sondage qui demandait aux répondants s’ils étaient en faveur de l’implantation d’un site de réduction des méfaits supervisé par du personnel médical qualifié pour les personnes consommatrices. </p>
        </div>
        </div>
        <p id="sb-1-10-p3" class="pt-5">Le <strong class="text-purple">nom</strong> donné au site a eu une <strong class="text-purple">influence</strong> sur le soutien exprimé par les répondants.</p>
        <ul id="sb-1-10-u1">
          <li><strong>45 % </strong> d’entre eux étaient en faveur d’un «{{'\xa0'}}site de prévention des surdoses{{'\xa0'}}» </li>
          <li><strong>Seuls 29 % </strong> étaient en faveur d’un «{{'\xa0'}}site de consommation sécuritaire{{'\xa0'}}» </li>
        </ul>
        <p d="sb-1-10-p4">C’est le nom qui insistait sur les conséquences d’une <strong class="text-purple">non-assistance à personne en danger</strong> qui a suscité la compassion des répondants et recueilli le plus de soutien. </p>
        <button-sequenced
          class="btn-nav--blue"
          :loc="11"
          link="sb-1-11"
        >
          Continue
        </button-sequenced>
      </content-block>
    </div>

    <!-- 1-11 -->
    <div id="sb-1-11" class="panel panel__parallax--chevron-bg d-flex align-items-center justify-content-center" v-if="$store.state.currentLocation >= 11">
      <!-- <div id="" class="panel__parallax panel__parallax--chevron-bg" style=""></div> -->
      <content-block class="">
        <div class="row align-items-center">
          <div class="col-2">
            <img src="@/assets/img/_ui/group-chevron.svg" alt="" class="content-block__img img-fluid">
          </div>
          <div class="col">
            <p>Une autre étude demandait aux participants leur opinion sur deux personnes « consommant activement de la drogue et de l’alcool ». </p>
            <p>On décrivait l’une d’elles comme un <em>toxicomane</em> et l’autre comme une  <strong class="text-purple">personne ayant un trouble lié à l’usage de substances</strong>. </p>
            <p>Les participants avaient tendance à considérer la personne ayant un trouble lié à l’usage de substances <strong class="text-purple">comme plus susceptible de bénéficier </strong> du traitement. </p>
            <!-- <p>The <em>substance abuser</em>, on the other hand, was perceived as reckless, and was thought to pose a greater social threat.</p> -->
          </div>
        </div>
        <!-- <img src="@/assets/img/1-12-bubble.svg" alt="One study found that 50% of respondents said they would not want someone with a drug addiction history as their neighbour." id="sb-1-11-bubble" class="content-block__img img-fluid"> -->
        <button-sequenced
          class="btn-nav--blue"
          :loc="12"
          link="sb-1-12"
        >
          Continue
        </button-sequenced>
      </content-block>
    </div>

    <!-- 1-12 -->
    <div id="sb-1-12" class="panel bg-blue full-height" v-if="$store.state.currentLocation >= 12">
      <div id="" class="panel__parallax panel__parallax--blue-bg" style=""></div>
      <content-block class="content-block--full-height">
        <p>Selon vous, pourquoi cela fait-il une si grosse différence de dire qu’une personne «{{'\xa0'}}a un trouble lié à l’usage de substances{{'\xa0'}}» plutôt que de la désigner comme une <em><strong>toxicomane</strong></em>? </p>
        <p></p>
        <button-sequenced
          class="btn-nav--white"
          :loc="13"
          link="sb-1-13"
        >
          Keep going
        </button-sequenced>
      </content-block>
    </div>

    <!-- 1-14 -->
    <div id="sb-1-13" class="panel bg-light-pink  d-flex align-items-center justify-content-center full-height" v-if="$store.state.currentLocation >= 13">
      <!-- <div id="" class="panel__parallax panel__parallax--chevron-bg" style=""></div> -->
      <content-block class="">
        <div class="row">
          <div class="col-3">
            <img src="@/assets/img/_ui/group-chevron.svg" alt="" class="content-block__img img-fluid">
          </div>
          <div class="col">
            <p>Désigner une personne comme un <em>toxicomane</em> laisse croire que  <strong class="text-purple">c’est la personne qui est le problème</strong>.</p>
            <p>Parler d’elle en disant qu’elle a un <strong class="text-purple">trouble lié à l’usage de substances</strong> met l’accent sur le problème de santé; on exprime ainsi que la <strong class="text-purple">personne éprouve le problème</strong>, plutôt que d’<em>être  le problème</em>.</p>
            <button-sequenced
              class="btn-nav--blue"
              :loc="14"
              link="sb-1-14"
            >
              Continue
            </button-sequenced>
          </div>
        </div>
      </content-block>
    </div>
    <!-- 1-14 -->
    <div id="sb-1-14" class="panel full-height" v-if="$store.state.currentLocation >=14">
      <!-- <div id="" class="panel__parallax panel__parallax--blue-bg" style=""></div> -->
      <content-block class="content-block--full-height">
        <p style="font-family:rockwell"><span style="font-size: 3rem;">Choisir les bons mots, pour sauver des vies.</span></p>
        <p>La stigmatisation est un <strong class="text-purple">obstacle de taille</strong> pour les millions de personnes qui répondent aux critères diagnostiques du trouble lié à l’usage de substances. </p>
        <p>En éliminant la stigmatisation et en faisant preuve de compréhension, on encourage de plus en plus de gens à suivre un traitement et à vivre une vie saine et enrichissante.</p>
        <button-sequenced
          class="btn-nav--white-2"
          :loc="16"
          link="sb-1-16"
        >
          Understood
        </button-sequenced>
      </content-block>
    </div>

    <!-- 1-15 -->
    <!-- <div id="sb-1-15" class="panel panel__parallax--chevron-bg" v-if="$store.state.currentLocation >= 15">
      <content-block class="">
        <p class="text-purple jumbo-text"><strong>Illuminer</strong></p>
        <p>Elaine Hyshka, Ph.D., professeure adjointe à l’École de santé publique de l’Université de l’Alberta, et Barry Andres, directeur général, Dépendance et santé mentale, Services de santé de l’Alberta, parlent de l’importance de parler ouvertement du trouble lié à l’usage de substances.</p>
        <div class="">
          <video
            src="@/assets/video/3-15.mp4"
            poster="@/assets/img/_poster/3-15.png"
            @ended="replayVideo($event)"
            controls controlsList="nodownload"
            class="img-fluid"
          >
          </video>
        </div>
        <div class="accordion-group accordion-group--pink">
          <accordion-icon headerText="Transcription">
            <p>Au cours des dernières années, en particulier, nous avons assisté à une sorte de changement. Les gens sont plus ouverts à parler d’abus de substances. J’aimerais vraiment que la société cesse de criminaliser les personnes qui prennent de la drogue. </p>
            <p>Nous avons le jugement facile. Nous avons tendance à chercher des solutions rapides, mais il ne faut pas oublier l’élément humain. Si c’était mon fils, ma fille, ma mère ou mon père, qu’est-ce que je voudrais pour eux? </p>
            <p>Essayer de se mettre à la place de l’autre, d’imaginer ce que c’est que d’avoir un grave problème de santé, et de ne pas savoir vers qui se tourner. Je parle souvent de cette question, parce qu’il faut la sortir de l’ombre. Elle est tellement mal comprise et stigmatisée, et il faudrait que ça change. Je saisis chaque occasion d’influencer les politiques ou les pratiques, ou même le cœur ou l’esprit de gens ordinaires, dont mes proches et mes amis. Je ne recule jamais devant cette conversation. Je la trouve importante.  </p>
            <p>Données. Engagement. Résultats. Le Centre canadien sur les dépendances et l’usage de substances, des connaissances qui inspirent.</p>
          </accordion-icon>
        </div>
        <button-sequenced
          class="btn-nav--blue"
          :loc="16"
          link="sb-1-16"
        >
          Continue
        </button-sequenced>
      </content-block>
    </div> -->

    <!-- 1-16 -->
    <div id="sb-1-16" class="panel panel__parallax--1-14 full-height d-flex align-items-center justify-content-center" v-if="$store.state.currentLocation >= 16">
      <content-block>
        <p class="jumbo-text text-purple">Langage axé sur la personne  </p>
        <p>Une <strong class="text-purple">personne</strong> qui consomme ou a reçu un diagnostic de trouble lié à l’usage de substances est &#8288;—&#8288; d’abord et avant tout &#8288;—&#8288; une personne.  </p>
        <p>L’emploi d’un langage axé sur l’identité, qui associe l’identité d’une personne à une caractéristique personnelle ou à un problème de santé, peut être déshumanisant.</p>
        <p><strong class="text-purple">Une personne ne se définit pas en fonction d’une maladie ou d’un problème de santé</strong>, et ce principe de base s’applique aussi aux personnes ayant un trouble lié à l’usage de substances.</p>
        <div class="accordion-group accordion-group--pink mb-0" >
          <accordion-icon headerText="Expression axée sur la personne à utiliser ">
            <p>Personne ayant un trouble lié à l’usage d’alcool</p>
          </accordion-icon>
        </div>
        <div class="accordion-group accordion-group--blue mt-0">
          <accordion-icon headerText="Expression axée sur l’identité à éviter">
            <p>Alcoolique, ivrogne</p>
          </accordion-icon>
        </div>
        <div class="accordion-group accordion-group--pink mb-0">
          <accordion-icon headerText="Expression axée sur la personne à utiliser">
            <p>Personne ayant un trouble lié à l’usage d’opioïdes</p>
          </accordion-icon>
        </div>
        <div class="accordion-group accordion-group--blue mt-0">
          <accordion-icon headerText="Expression axée sur l’identité à éviter">
            <p>Drogué </p>
          </accordion-icon>
        </div>
        <div class="accordion-group accordion-group--pink mb-0">
          <accordion-icon headerText="Expression axée sur la personne à utiliser">
            <p>Personne qui a vécu le trouble lié à l’usage de substances </p>
          </accordion-icon>
        </div>
        <div class="accordion-group accordion-group--blue mt-0">
          <accordion-icon headerText="Expression axée sur l’identité à éviter">
            <p>Toxicomane</p>
          </accordion-icon>
        </div>
        <div class="accordion-group accordion-group--pink mb-0">
          <accordion-icon headerText="Expression axée sur la personne à utiliser">
            <p>Personne qui consomme </p>
          </accordion-icon>
        </div>
        <div class="accordion-group accordion-group--blue mt-0">
          <accordion-icon headerText="Expression axée sur l’identité à éviter">
            <p>Drogué, accro</p>
          </accordion-icon>
        </div>
        <div class="accordion-group accordion-group--pink mb-0">
          <accordion-icon headerText="Expression axée sur la personne à utiliser">
            <p>Personne ayant fait une intoxication à une substance</p>
          </accordion-icon>
        </div>
        <div class="accordion-group accordion-group--blue mt-0">
          <accordion-icon headerText="Expression axée sur l’identité à éviter">
            <p>Victime de surdose</p>
          </accordion-icon>
        </div>
        <div class="accordion-group accordion-group--pink mb-0">
          <accordion-icon headerText="Expression axée sur la personne à utiliser">
            <p>Personne qui s’adonne à une forte consommation épisodique d’alcool ou de drogue</p>
          </accordion-icon>
        </div>
        <div class="accordion-group accordion-group--blue mt-0">
          <accordion-icon headerText="Expression axée sur l’identité à éviter">
            <p>Buveur excessif, consommateur compulsif</p>
          </accordion-icon>
        </div>
        <div class="accordion-group accordion-group--pink mb-0">
          <accordion-icon headerText="Expression axée sur la personne à utiliser">
            <p>Personne qui prend des substances à des fins non médicales (dans certains contextes)</p>
            <p>Personne qui fait un usage occasionnel de substances (dans certains contextes)</p>
          </accordion-icon>
        </div>
        <div class="accordion-group accordion-group--blue mt-0">
          <accordion-icon headerText="Expression axée sur l’identité à éviter">
            <p>Consommateur de substances à usage récréatif</p>
          </accordion-icon>
        </div>
        <button-sequenced
          class="btn-nav--blue"
          :loc="17"
          link="sb-1-17"
        >
          Continue
        </button-sequenced>
      </content-block>
    </div>

     <!-- 1-17 -->
    <div id="sb-1-17" class="panel bg-blue full-height" v-if="$store.state.currentLocation >= 17">
      <div id="" class="panel__parallax panel__parallax--blue-bg" style=""></div>
      <content-block class="content-block--full-height">
        <p>Pensez à un mot stigmatisant que vous pourriez commencer à remplacer par un <strong>mot axé sur la personne</strong> et formulez une phrase avec ce mot plus bienveillant.</p>
        <p></p>
        <button-sequenced
          class="btn-nav--white"
          :loc="17.5"
          link="sb-1-17a"
        >
          Keep going
        </button-sequenced>
      </content-block>
    </div>

     <!-- 1-17a -->
    <div id="sb-1-17a" class="panel panel__parallax--chevron-bg" v-if="$store.state.currentLocation >= 17.5">
      <div id="" class="panel__parallax panel__parallax--chevron-bg" style=""></div>
      <content-block class="">
        <p class="text-purple jumbo-text">La stigmatisation et la discrimination dans le langage de la dépendance (CCDUS)</p>
        <p>Kenneth Tupper, Ph.D.</p>
        <div class="">
          <!-- <iframe width="auto" height="100%" src="https://www.youtube.com/embed/bQrNSXE1OMU?rel=0&start=34&end=57" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
          <!-- poster="@/assets/img/_poster/1-08a.png" -->
          <video src="@/assets/video/3-17a.mp4" poster="@/assets/img/_poster/3-17a.png" @ended="replayVideo($event)" controls class="img-fluid"></video>
        </div>
        <div class="accordion-group accordion-group--pink">
          <accordion-icon headerText="Transcription">
            <p>Pendant longtemps, nous avons stigmatiser (sic) les gens qui consommaient de la drogue avec des termes désobligeants comme drogué ou accro, mais nous comprenons maintenant que ce sont des gens et que de penser à eux d’abord en tant que personnes est très important, non seulement dans la façon dont nous pensons mais aussi dans la façon dont nous parlons. Donc parler de personnes qui utilisent de la drogue, plutôt que, disons, drogué ou accro ou même consommateur de drogues, est une évolution vers un cadre plus centré sur la personne.  </p>
          </accordion-icon>
        </div>
        <button-sequenced
          class="btn-nav--blue"
          :loc="18"
          link="sb-1-18"
        >
          Continue
        </button-sequenced>
      </content-block>
    </div>

    <!-- 1-18 -->
    <div id="sb-1-18" class="panel panel__parallax--1-14 full-height d-flex align-items-center justify-content-center" v-if="$store.state.currentLocation >= 18">
      <content-block>
        <p> Il faudrait aussi employer des mots axés sur la personne pour parler des gens qui ont déjà consommé des substances.</p>
         <div class="accordion-group accordion-group--pink mb-0 pt-5" >
          <accordion-icon headerText="Expression axée sur la personne à utiliser  ">
            <p>Personne ayant une expérience concrète</p>
            <p>Personne ayant consommé des substances </p>
            <p>Personne ayant des antécédents d’usage de substances</p>
          </accordion-icon>
        </div>
        <div class="accordion-group accordion-group--blue mt-0">
          <accordion-icon headerText="Expression axée sur l’identité à éviter">
            <p>Ex-toxicomane, ancien toxicomane, ancien accro</p>
          </accordion-icon>
        </div>
        <div class="accordion-group accordion-group--pink mb-0">
          <accordion-icon headerText="Expression axée sur la personne à utiliser ">
            <p>Personne en rétablissement (d’un trouble lié à l’usage de substances)</p>
          </accordion-icon>
        </div>
        <div class="accordion-group accordion-group--blue mt-0">
          <accordion-icon headerText="Expression axée sur l’identité à éviter">
            <p>Alcoolique en rétablissement, toxicomane en rétablissement </p>
          </accordion-icon>
        </div>
        <div class="accordion-group accordion-group--pink mb-0">
          <accordion-icon headerText="Expression axée sur la personne à utiliser ">
            <p>Personne ayant vécu le trouble lié à l’usage d’alcool </p>
          </accordion-icon>
        </div>
        <div class="accordion-group accordion-group--blue mt-0">
          <accordion-icon headerText="Expression axée sur l’identité à éviter">
            <p>Ancien alcoolique</p>
          </accordion-icon>
        </div>
        <button-sequenced
          class="btn-nav--blue"
          :loc="19"
          link="sb-1-19"
        >
          Continue
        </button-sequenced>
      </content-block>
    </div>
    <!-- 1-19 -->

    <div id="sb-1-19" class="panel panel__parallax--1-14 d-flex align-items-center justify-content-center" v-if="$store.state.currentLocation >= 19">
      <!-- <div id="" class="panel__parallax panel__parallax--blue-bg" style=""></div> -->
      <content-block class="sb-1-19">
        <p>Il existe un autre ensemble de termes stigmatisants qui peuvent faire baisser l’estime de soi et diminuer l’efficacité du traitement reçu.</p>
        <ul class="patterned-list">
          <li>«{{'\xa0'}}Il est  <strong><em class="text-purple">propre</em></strong> et sobre depuis 6 mois.{{'\xa0'}}»</li>
          <li>«{{'\xa0'}}Elle a  <strong><em class="text-purple">échoué</em></strong> un test de dépistage la dernière fois.{{'\xa0'}}»</li>
          <li>«{{'\xa0'}}On ne peut pas te traiter tant que tu n’es pas  <strong><em class="text-purple">"clean".</em></strong>{{'\xa0'}}»</li>
        </ul>
        <p>Les mots <em>propre, «{{'\xa0'}}clean{{'\xa0'}}»</em> et <em>échec</em> sont couramment utilisés dans le secteur de la santé et ailleurs. Ce sont des expressions <strong>stigmatisantes</strong> qui impliquent un jugement de valeur.</p>
        <button-sequenced
          class="btn-nav--blue"
          :loc="20"
          link="sb-1-20"
        >
          Continue
        </button-sequenced>
      </content-block>
    </div>

    <!-- 1-20 -->
    <div id="sb-1-20" class="panel bg-light-pink  d-flex align-items-center justify-content-center full-height" v-if="$store.state.currentLocation >= 20">
      <div id="" class="" style=""></div>
      <content-block class="">
        <div class="row align-items-center">
          <div class="col-2">
            <img src="@/assets/img/_ui/group-chevron.svg" alt="" class="content-block__img img-fluid">
          </div>
          <div class="col">
            <p class="jumbo-text text-purple">Utilisation de termes médicalement exacts </p>
            <p>En parlant des résultats de tests de dépistage toxicologique, utilisons toujours «{{'\xa0'}}positif{{'\xa0'}}» et «{{'\xa0'}}négatif{{'\xa0'}}».</p>
            <p>En parlant d’une personne, réfléchissons à ce que nous sous-entendons avec le mot «{{'\xa0'}}propre{{'\xa0'}}». </p>
            <p>En changeant les termes que nous employons, nous pouvons aider à <strong class="text-purple">combattre les stéréotypes négatifs</strong> une conversation à la fois.  </p>
          </div>
        </div>
        <button-sequenced
          class="btn-nav--blue"
          :loc="21"
          link="sb-1-21"
        >
          Continue
        </button-sequenced>
      </content-block>
    </div>
    <!-- 1-21 -->
    <div id="sb-1-21" class="panel bg-blue full-height" v-if="$store.state.currentLocation >= 21">
      <div id="" class="panel__parallax panel__parallax--blue-bg" style=""></div>
      <content-block class="content-block--full-height">
        <p>Parmi les membres de votre famille, vos amis ou vos connaissances, y a-t-il une ou deux personnes qui <strong>vivent ou ont vécu l’usage de substances</strong>? </p>
        <p>Prenez quelques instants pour décrire leur cheminement à l’aide d’expressions axées sur la personne.</p>
        <button-sequenced
          class="btn-nav--white"
          :loc="22"
          link="sb-1-22"
        >
          Keep going
        </button-sequenced>
      </content-block>
    </div>

     <!-- 1-22 -->
    <div id="sb-1-22" class="panel panel__parallax--chevron-bg d-flex align-items-center justify-content-center" v-if="$store.state.currentLocation >= 22">
      <content-block>
        <img src="@/assets/img/3-22-fr.svg" alt="Les mots ont du pouvoir. Ils ont le pouvoir d’enseigner, de blesser, d’influencer notre façon de penser, de ressentir et d’agir" class="content-block__img img-fluid" id="sb-1-19a-image">
        <p class="text-center">- Otto Wahl, Ph. D, psychologue clinicien et professeur de psychologie, université George Mason, Fairfax, Virginia</p>
        <button-sequenced
          class="btn-nav--blue"
          :loc="22.5"
          link="sb-1-22a"
        >
          Continue
        </button-sequenced>
      </content-block>
    </div>

    <!-- 1-23 -->
    <div id="sb-1-22a" class="panel panel__parallax--chevron-bg" v-if="$store.state.currentLocation >= 22.5">
      <!-- <div id="" class="panel__parallax panel__parallax--chevron-bg" style=""></div> -->
      <content-block class="">
        <p class="text-purple jumbo-text">Que peut-on faire pour mettre un terme à la stigmatisation? (CCDUS)</p>
        <p>Christopher Cull, directeur, Inspires  </p>
        <div class="">
          <!-- <iframe width="auto" height="100%" src="https://www.youtube.com/embed/DhO5OL27eC8?rel=0&start=00&end=14" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
           <!-- poster="@/assets/img/_poster/1-19a.png" -->
          <video src="@/assets/video/3-22a.mp4" poster="@/assets/img/_poster/3-22a.png" @ended="replayVideo($event)" controls class="img-fluid">
            <!-- <track label="English" kind="subtitles" srclang="en" :src="`${publicPath}cc/ccsa-19aebe8e20d.en.vtt`" default> -->
          </video>
        </div>
        <div class="accordion-group accordion-group--pink">
          <accordion-icon headerText="Transcription">
            <p>Changer notre façon de concevoir le trouble lié aux substances et d’en parler peut aider.</p>
            <p>Je crois fermement que le langage est important. Il est essentiel pour changer la mentalité et la façon de traiter les personnes souffrant de dépendance et de troubles de santé mentale. C’est là la différence entre te faire sentir comme un moins que rien ou te mettre suffisamment à l’aise pour que tu puisses aller chercher l’aide dont tu as besoin, ce qui est crucial, surtout pour sauver une vie.</p>
          </accordion-icon>
        </div>
        <button-sequenced
          class="btn-nav--blue"
          :loc="23"
          link="sb-1-23"
        >
          Continue
        </button-sequenced>
      </content-block>
    </div>
    <!-- 1-23 -->
    <div id="sb-1-23" class="panel panel__parallax--1-21 full-height d-flex align-items-center justify-content-center" v-if="$store.state.currentLocation >= 23">
      <!-- <div id="" class="panel__parallax panel__parallax--1-21" style=""></div> -->
      <content-block class="">
        <div class="row align-items-center">
          <div class="col-2">
            <img src="@/assets/img/_ui/group-chevron.svg" alt="" class="content-block__img img-fluid">
          </div>
          <div class="col">
            <h2 class="text-purple">Il est important de réfléchir à la façon dont{{'\xa0'}}:</h2>
            <ul>
              <li>Le langage  <strong class="text-purple">influence</strong> nos biais cognitifs, notamment en ce qui concerne l’usage de substances.</li>
              <li>Les mots que nous employons  <strong class="text-purple">reflètent</strong> nos jugements, nos attitudes et nos gestes. </li>
              <li>Nos paroles  <strong class="text-purple">façonnent</strong> nos pensées et la façon dont nous considérons les choses, et il en va de même pour les autres.</li>
              <li>Changer notre façon de parler peut être la première étape pour aider une personne à demander de l’aide.</li>
            </ul>
          </div>
        </div>
        <button-sequenced
          class="btn-nav--blue"
          :loc="25"
          link="sb-1-25"
        >
          I'm ready
        </button-sequenced>
      </content-block>
    </div>

    <!-- <div id="sb-1-24" class="panel full-height" v-if="$store.state.currentLocation >=24">
      <content-block class="content-block--full-height">
        <p>Thank you for taking time to uncover the science on substance use disorders. </p>
        <p>We <strong class="text-purple">make a difference</strong> when we use words that respect the dignity of all people, focus on the medical nature of substance use disorders and do our part to overcome stigma through language. </p>
        <button-sequenced
          class="btn-nav--white-2"
          :loc="25"
          link="sb-1-25"
        >
          Understood
        </button-sequenced>
      </content-block>
    </div> -->

      <!-- 1-25 -->
      <content-block id="sb-1-25" class="stigma-wrapper" v-if="$store.state.currentLocation >= 25">
        <!-- 1-28-01 -->
        <div id="stigma-01" class="stigma" v-if="$store.state.currentLocation === 25">
          <div class="stigma__wrong">
            <!-- <div class="stigma__wrong-cross"></div> -->
            <p class="stigma-wrong__text"><em>«{{'\xa0'}}L’<strong>abus de substances</strong> affecte des Canadiens de tous horizons.{{'\xa0'}}»</em></p>
            <!-- <p class="stigma-wrong__text-strike">Using drugs is a <strong>choice</strong>, they just need to stop</p> -->
          </div>
          <div class="stigma__right">
            <p class="stigma__right-text">Des Canadiens de tous horizons sont vulnérables aux risques du <strong>trouble lié à l’usage de substances</strong>.</p>
          </div>
          <button-sequenced
            class="btn-nav--blue"
            :loc="25.1"
            link="sb-1-28"
          >
            Continue
          </button-sequenced>
        </div>

        <!-- 1-28-02 -->
        <div id="stigma-02" class="stigma" v-if="$store.state.currentLocation === 25.1">
          <div class="stigma__wrong">
              <!-- <div class="stigma__wrong-cross"></div> -->
              <p class="stigma-wrong__text"><em>«{{'\xa0'}}Elle est <strong>propre</strong> depuis presque un an.{{'\xa0'}}»</em></p>
            <!-- <div class="position-relative d-inline-block">
              <div class="stigma__wrong-cross"></div>
              <p class="stigma-wrong__text">If they even have a job, they’re probably <strong>untrustworthy employees</strong>.</p>
            </div> -->
          </div>
          <div class="stigma__right">
            <p class="stigma__right-text">«{{'\xa0'}}Elle n’a <strong>pas consommé</strong> depuis presque un an.{{'\xa0'}}»</p>
          </div>
          <button-sequenced
            class="btn-nav--blue"
            :loc="25.2"
            link="sb-1-28"
          >
            Continue
          </button-sequenced>
        </div>

        <!-- 1-28-03 -->
        <div id="stigma-03" class="stigma" v-if="$store.state.currentLocation === 25.2">
          <div class="stigma__wrong">
            <!-- <div class="stigma__wrong-cross"></div> -->
            <p class="stigma-wrong__text"><em>«{{'\xa0'}}Il va probablement <strong>rechuter</strong>.{{'\xa0'}}»</em></p>
          </div>
          <div class="stigma__right">
            <p class="stigma__right-text">La <strong>récurrence</strong> fait partie du trouble lié à l’usage de substances.  </p>
          </div>
          <button-sequenced
            class="btn-nav--blue"
            :loc="25.3"
            link="sb-1-28"
          >
            Continue
          </button-sequenced>
        </div>

        <!-- 1-28-04 -->
        <div id="stigma-04" class="stigma" v-if="$store.state.currentLocation === 25.3">
          <div class="stigma__wrong">
            <!-- <div class="stigma__wrong-cross"></div> -->
            <p class="stigma-wrong__text"><em>«{{'\xa0'}}Je vois beaucoup de <strong>buveurs compulsifs</strong> depuis quelque temps.{{'\xa0'}}»</em></p>
          </div>
          <div class="stigma__right">
            <p class="stigma__right-text">La <strong>forte consommation épisodique d’alcool</strong> est un exemple d’usage malsain d’alcool.</p>
          </div>
          <button-sequenced
            class="btn-nav--blue"
            :loc="25.4"
            link="sb-1-28"
          >
            Continue
          </button-sequenced>
        </div>

        <!-- 1-28-05 -->
        <div id="stigma-05" class="stigma" v-if="$store.state.currentLocation >= 25.4">
          <div class="stigma__wrong">
            <!-- <div class="stigma__wrong-cross"></div> -->
            <p class="stigma-wrong__text"><em>«{{'\xa0'}}La <strong>dépendance</strong> aux opioïdes est une condamnation à mort pour beaucoup.{{'\xa0'}}»</em></p>
          </div>
          <div class="stigma__right">
            <p class="stigma__right-text">Les personnes traitées pour un <strong>trouble lié à l’usage d’opioïdes</strong> peuvent vivre une <strong>vie épanouie et heureuse</strong>.</p>
          </div>
          <button-sequenced
            class="btn-nav--blue"
            :loc="26"
            link="sb-1-26"
          >
            Continue
          </button-sequenced>
        </div>
      </content-block>

    <div id="sb-1-26" class="panel bg-charcoal full-height d-flex align-items-center justify-content-center" v-if="$store.state.currentLocation >= 26">
      <content-block class="pt-0">
        <h2 class="jumbo-text text-center">Mon engagement </h2>
        <p>Je m’engage à faire ces quatre gestes dès aujourd’hui pour éliminer la stigmatisation. </p>
        <ul>
          <li>J’utiliserai un <strong class="text-beige">langage axé sur la personne</strong>. </li>
          <li>J’utiliserai <strong class="text-beige">des termes médicalement exacts</strong>. </li>
          <li>Je <strong class="text-beige">réagirai aux expressions stigmatisantes</strong> utilisées par mon entourage.</li>
          <li>Je <strong class="text-beige">m’exprimerai ouvertement sur l’usage de substances </strong> et j’encouragerai les autres à faire de même.</li>
        </ul>
        <button
          class="btn-nav btn-nav--normal-white"
          @click="openPopup = true"
          v-if="!courseCompleted"
        >
          Je le ferai
        </button>
      </content-block>
    </div>

    <modal-popup v-if="openPopup" @close="openPopup = false, courseCompleted = true">
      <content-block class="">
        <img src="@/assets/img/_branding/ccsa-logo-fr.svg" width="250px" alt="" class="content-block__img img-fluid">
        <p>Merci d’avoir pris le temps de mieux comprendre la stigmatisation entourant le trouble lié à l’usage de substances.  </p>
        <p>Nous pouvons <strong class="text-pruprle">changer les choses</strong> en employant des mots qui respectent la dignité de tous, en insistant sur l’aspect médical du trouble lié à l’usage de substances et en contribuant à faire reculer la stigmatisation. </p>
      </content-block>
    </modal-popup>

    <!-- Progress Bar -->
    <div class="progress-wrapper">
      <progress-bar
        size="large"
        :val="getCourseProgress"
        bar-color="#00B7F1"
      ></progress-bar>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import ContentBlock from '@/components/ContentBlock.vue'
import ButtonSequenced from '@/components/ButtonSequenced.vue'
import AccordionIcon from '@/components/AccordionIcon.vue'
import ModalPopup from '@/components/ModalPopup.vue'

import ProgressBar from 'vue-simple-progress'

// GSAP STUFF
import { TimelineMax } from 'gsap'

// jQuery
const $ = require('jquery')
window.$ = $

export default {
  name: 'Home',
  components: {
    ContentBlock,
    ButtonSequenced,
    AccordionIcon,
    ModalPopup,
    ProgressBar
  },
  data () {
    return {
      publicPath: process.env.BASE_URL,
      openPopup: false,
      courseCompleted: false
    }
  },
  updated () {
    /**
     * 1-00
     */
    if (this.$store.state.currentLocation === 0.5) {
      const sbTimeline00 = new TimelineMax()
        .from('#sb-1-00>.panel__parallax', 1, { y: '20%' }, 'first')
        .staggerFrom('#sb-1-00 p', 0.5, { alpha: 0 }, 0.5, 'first')
        .from('#sb-1-00 button', 0, { alpha: 0, y: -20 })

      const sbScene00 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-00',
        triggerHook: '0.5',
        duration: 0
      })
        // .setPin('#sb-1-00', { pushFollowers: true })
        .setTween(sbTimeline00)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene00)
    }

    /**
     * 1-01
     */
    if (this.$store.state.currentLocation === 1) {
      const wipeAnimation = new TimelineMax()
        // .to('#sb-1-01-p1', 0.5, { color: '#D40E8C', scale: '1.1' })
        // .to('#sb-1-01-p1', 0.5, { color: '#5D6978', scale: '1' })
        // .to('#sb-1-01-p2', 0.5, { color: '#D40E8C', scale: '1.1' })
        // .to('#sb-1-01-p2', 0.5, { color: '#5D6978', scale: '1' })
        // .to('#sb-1-01-p3', 0.5, { color: '#D40E8C', scale: '1.1' })
        // .to('#sb-1-01-p3', 0.5, { color: '#5D6978', scale: '1' })
        .staggerFrom('#sb-1-01 p', 2, { alpha: 0, color: '#D40E8C', scale: '1.1' }, 1)
        // .staggerTo('#sb-1-01 p', 0.5, { color: '#5D6978', scale: '1' }, 0.25)
        .from('#sb-1-01 button', 0, { alpha: 0, y: -20 })
      const pinScene = this.$scrollmagic.scene({
        triggerElement: '#sb-1-01',
        triggerHook: '0.5',
        duration: 0
      })
        // .setPin('#sb-1-01', { pushFollowers: true })
        .setTween(wipeAnimation)
        // .addIndicators() // add indicators (requires plugin)
        // .addTo(controller)
      this.$scrollmagic.addScene(pinScene)
    }

    /**
     * 1-02
     */
    if (this.$store.state.currentLocation === 2) {
      const sbTimeline02 = new TimelineMax()
        .from('#sb-1-02>.panel__parallax', 1, { y: '20%' }, 'first')
        .staggerFrom('#sb-1-02 p', 0.5, { alpha: 0 }, 0.5, 'first')
        .from('#sb-1-02 button', 0, { alpha: 0, y: -20 })

      const sbScene02 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-02',
        triggerHook: '0.5',
        duration: 0
      })
        // .setPin('#sb-1-02', { pushFollowers: true })
        .setTween(sbTimeline02)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene02)
    }

    /**
     * 1-03
     */
    if (this.$store.state.currentLocation === 3) {
      const sbTimeline03 = new TimelineMax()
        .from('#sb-1-03>.panel__parallax', 1, { y: '20%' }, 'first', 'second')
        .staggerFrom('#sb-1-03-p1', 1, { alpha: 0 }, 0.5, 'first')
        .staggerFrom('#sb-1-03-p2', 1, { alpha: 0 }, 0.5, 'first')
        .staggerFrom('#sb-1-03-img-01', 1, { alpha: 0 }, 0.5, 'first')
        .staggerFrom('#sb-1-03-p3', 1, { alpha: 0 }, 0.5, 'second')
        .staggerFrom('#sb-1-03-img-02', 1, { alpha: 0 }, 0.5, 'second')
        .from('#sb-1-03 button', 0, { alpha: 0, y: '20px' }, 'second')

      const sbScene03 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-03',
        triggerHook: '0.5',
        duration: 0
      })
        .setTween(sbTimeline03)
      this.$scrollmagic.addScene(sbScene03)
    }

    /**
     * 1-04
     */
    if (this.$store.state.currentLocation === 4) {
      const sbTimeline04 = new TimelineMax()
        .from('#sb-1-04>.panel__parallax', 1, { y: '20%' }, 'first')
        .staggerFrom('#sb-1-04 p', 1, { alpha: 0 }, 0.5, 'first')
        .from('#sb-1-04 button', 0, { alpha: 0, y: '20px' }, 'second')

      const sbScene04 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-04',
        triggerHook: '0.5',
        duration: 0
      })
        .setTween(sbTimeline04)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene04)
    }

    /**
     * 1-05
     */
    if (this.$store.state.currentLocation === 5) {
      const sbTimeline05 = new TimelineMax()
        .from('#sb-1-05>.panel__parallax', 1, { y: '20%' }, 'first')
        .staggerFrom('#sb-1-05 p', 1, { alpha: 0 }, 0.5, 'first')
        .from('#sb-1-05 button', 0, { alpha: 0, y: -20 })

      const sbScene05 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-05',
        triggerHook: '0.5',
        duration: 0
      })
        // .setPin('#sb-1-05', { pushFollowers: true })
        .setTween(sbTimeline05)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene05)
    }

    /**
     * 1-06
     */
    if (this.$store.state.currentLocation === 6) {
      const sbTimeline06 = new TimelineMax()
        .from('#sb-1-06>.panel__parallax', 1, { y: '20%' }, 'first')
        .staggerFrom('#sb-1-06 p', 1, { alpha: 0 }, 0.5, 'first')
        .staggerFrom('#sb-1-06 .accordion-group', 1, { alpha: 0 }, 0.5, 'first')
        .from('#sb-1-06 button', 0, { alpha: 0, y: '20px' }, 'first')

      const sbScene06 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-06',
        triggerHook: '0.5',
        duration: 0
      })
        // .setPin('#sb-1-06', { pushFollowers: false })
        .setTween(sbTimeline06)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene06)
    }

    /**
     * 1-07
     */
    if (this.$store.state.currentLocation === 7) {
      const sbTimeline07 = new TimelineMax()
        .from('#sb-1-07>.panel__parallax', 1, { y: '20%' }, 'first')
        .staggerFrom('#sb-1-07 p', 1, { alpha: 0 }, 0.5, 'first')
        .from('#sb-1-07 button', 0, { alpha: 0, y: -20 })

      const sbScene07 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-07',
        triggerHook: '0.5',
        duration: 0
      })
        // .setPin('#sb-1-07', { pushFollowers: true })
        .setTween(sbTimeline07)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene07)
    }

    /**
     * 1-08
     */
    if (this.$store.state.currentLocation === 8) {
      const sbTimeline08 = new TimelineMax()
        .from('#sb-1-08>.panel__parallax', 1, { y: '20%' }, 'first')
        // .from('#sb-1-08-p1', 1, { alpha: 0 }, 0.5, 'first')
        // .from('#sb-1-08-p2', 1, { alpha: 0 }, 0.5, 'first')
        // .from('#sb-1-08-p3', 1, { alpha: 0 }, 0.5, 'first')
        // .from('#sb-1-08-p4', 1, { alpha: 0 }, 0.5, 'first')
        // .from('#sb-1-08 p', 1, { alpha: 0 }, 0.5, 'third')
        .staggerFrom('#sb-1-08 p', 1, { alpha: 0 }, 0.5, 'first')
        // .from('#sb-1-08-image', 1, { alpha: 0 }, 0.5, 'first')
        .from('#sb-1-08 ul', 1, { alpha: 0 }, 0.5, 'first')
        // .from('#sb-1-08 strong', 1, { color: '#5D6978' }, 0.5, 'first')
        .from('#sb-1-08 button', 0, { alpha: 0, y: '20px' }, 'first')

      const sbScene08 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-08',
        triggerHook: '0.5',
        duration: 0
      })
        // .setPin('#sb-1-08', { pushFollowers: false })
        .setTween(sbTimeline08)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene08)
    }

    /**
     * 1-09
     */
    if (this.$store.state.currentLocation === 9) {
      const sbTimeline09 = new TimelineMax()
        .from('#sb-1-09>.panel__parallax', 1, { y: '20%' }, 'first')
        .staggerFrom('#sb-1-09 p', 1, { alpha: 0 }, 0.5, 'first')
        // .staggerFrom('#sb-1-09 strong', 1, { color: '#5D6978' }, 0.5)
        // .staggerFrom('#sb-1-09 .accordion', 1, { alpha: 0 }, 0.2)
        .from('#sb-1-09 button', 0, { alpha: 0, y: -20 })
        // .from('#sb-1-09 .btn-nav', 0, { alpha: 0, y: '20px' })

      const sbScene09 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-09',
        triggerHook: '0.5',
        duration: 0
      })
        // // .setPin('#sb-1-09', { pushFollowers: true })
        .setTween(sbTimeline09)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene09)
    }

    /**
     * 1-10
     */
    if (this.$store.state.currentLocation === 10) {
      const sbTimeline10 = new TimelineMax()
        .from('#sb-1-10>.panel__parallax', 1, { y: '20%' }, 'first')
        .from('#sb-1-10-image', 1, { alpha: 0 }, 0.5, 'first')
        .staggerFrom('#sb-1-10 p', 1, { alpha: 0 }, 0.5, 'first')
        // .from('#sb-1-10-p1', 1, { alpha: 0 }, 0.5, 'first')
        // .from('#sb-1-10-p2', 1, { alpha: 0 }, 0.5, 'first')
        // .from('#sb-1-10-p3', 1, { alpha: 0 }, 0.5, 'first')
        .from('#sb-1-10 ul', 1, { alpha: 0 }, 1, 'first')
        // .from('#sb-1-10-p4', 1, { alpha: 0 }, 0.5, 'first')
        .from('#sb-1-10 button', 0, { alpha: 0, y: -20 })

      const sbScene10 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-10',
        triggerHook: '0.5',
        duration: 0
      })
        // .setPin('#sb-1-10', { pushFollowers: true })
        .setTween(sbTimeline10)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene10)
    }

    /**
     * 1-11
     */
    if (this.$store.state.currentLocation === 11) {
      const sbTimeline11 = new TimelineMax()
        // .from('#sb-1-11>.panel__parallax', 2, { y: '20%' }, 'first', 'second')
        .staggerFrom('#sb-1-11 p', 1, { alpha: 0 }, 0.5, 'first')
        // .staggerFrom('#sb-1-11 strong', 1, { color: '#5D6978' }, 0.5, 'second')
        .from('#sb-1-11-bubble', 1, { y: '20%', alpha: 0 }, 'second')
        // .from('#sb-1-11 button', 0, { alpha: 0, y: '20px'})
        .from('#sb-1-11 button', 0, { alpha: 0, y: -20 })

      const sbScene11 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-11',
        triggerHook: '0.5',
        duration: 0
      })
        // .setPin('#sb-1-11', { pushFollowers: false })
        .setTween(sbTimeline11)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene11)
    }

    /**
     * 1-12
     */
    if (this.$store.state.currentLocation === 12) {
      const sbTimeline12 = new TimelineMax()
        .from('#sb-1-12>.panel__parallax', 1, { y: '20%' }, 'first')
        .staggerFrom('#sb-1-12 p', 1, { alpha: 0 }, 0.5, 'first')
        // .staggerFrom('#sb-1-09 strong', 1, { color: '#5D6978' }, 0.5)
        // .staggerFrom('#sb-1-09 .accordion', 1, { alpha: 0 }, 0.2)
        // .from('#sb-1-12 .btn-nav', 0, { alpha: 0, y: '20px' }, 'second')
        .from('#sb-1-12 button', 0, { alpha: 0, y: -20 })

      const sbScene12 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-12',
        triggerHook: '0.5',
        duration: 0
      })
        // // .setPin('#sb-1-09', { pushFollowers: true })
        .setTween(sbTimeline12)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene12)
    }

    /**
     * 1-13
     */
    if (this.$store.state.currentLocation === 13) {
      const sbTimeline13 = new TimelineMax()
        .from('#sb-1-13>.panel__parallax', 1, { y: '20%' }, 'first')
        .staggerFrom('#sb-1-13 p', 1, { alpha: 0 }, 0.5, 'first')
        .from('#sb-1-13 button', 0, { alpha: 0, y: -20 })

      const sbScene13 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-13',
        triggerHook: '0.5',
        duration: 0
      })
        // .setPin('#sb-1-13', { pushFollowers: true })
        .setTween(sbTimeline13)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene13)
    }

    /**
     * 1-14
     */
    if (this.$store.state.currentLocation === 14) {
      const sbTimeline14 = new TimelineMax()
        .from('#sb-1-14>.panel__parallax', 1, { y: '20%' }, 'first')
        .from('#sb-1-14 p', 1, { alpha: 0 })
        // .staggerFrom('#sb-1-14 strong', 1, { color: '#5D6978' }, 0.5, 'second')
        // .staggerFrom('#sb-1-14 li', 1, { alpha: 0 })
        // .from('#sb-1-14-p2', 1, { alpha: 0 })
        .from('#sb-1-14 button', 0, { alpha: 0, y: '20px' })

      const sbScene14 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-14',
        triggerHook: '0.5',
        duration: 0
      })
        // // .setPin('#sb-1-14', { pushFollowers: true })
        .setTween(sbTimeline14)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene14)
    }

    // /**
    //  * 1-15
    //  */
    // if (this.$store.state.currentLocation === 15) {
    //   const sbTimeline15 = new TimelineMax()
    //     .from('#sb-1-15-panel-01', 1, { x: '-25%', alpha: 0 }, 'third')
    //     .from('#sb-1-15-panel-02', 1, { x: '25%', alpha: 0 }, 'third')
    //     .from('#sb-1-15 button', 0, { alpha: 0, y: '20px' }, 'fourth')

    //   const sbScene15 = this.$scrollmagic.scene({
    //     triggerElement: '#sb-1-15',
    //     triggerHook: '1',
    //     duration: 0
    //   })
    //     // // .setPin('#sb-1-14', { pushFollowers: true })
    //     .setTween(sbTimeline15)
    //     // .addIndicators() // add indicators (requires plugin)
    //   this.$scrollmagic.addScene(sbScene15)
    // }

    /**
     * 1-16
     */
    if (this.$store.state.currentLocation === 16) {
      const sbTimeline16 = new TimelineMax()
        .from('#sb-1-16>.panel__parallax', 1, { y: '20%' }, 'first')
        .from('#sb-1-16 p', 1, { alpha: 0 }, 0.5, 'first')
        .staggerFrom('#sb-1-16 .accordion', 1, { alpha: 0, delay: 0.5 }, 0.5, 'first')
        .from('#sb-1-16 button', 0, { alpha: 0, y: -20 }, 'first')

      const sbScene16 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-16',
        triggerHook: '0.5',
        duration: '0'
      })
        // .setPin('#sb-1-16', { pushFollowers: true })
        .setTween(sbTimeline16)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene16)
    }

    /**
     * 1-17
     */
    if (this.$store.state.currentLocation === 17) {
      const sbTimeline17 = new TimelineMax()
        .from('#sb-1-17>.panel__parallax', 1, { y: '20%' }, 'first')
        .staggerFrom('#sb-1-17 p', 1, { alpha: 0 }, 0.5, 'first')
        // .staggerFrom('#sb-1-09 strong', 1, { color: '#5D6978' }, 0.5)
        // .staggerFrom('#sb-1-09 .accordion', 1, { alpha: 0 }, 0.2)
        // .from('#sb-1-17 .btn-nav', 0, { alpha: 0, y: '20px' }, 'second')
        .from('#sb-1-17 button', 0, { alpha: 0, y: -20 })

      const sbScene17 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-17',
        triggerHook: '0.5',
        duration: 0
      })
        // // .setPin('#sb-1-09', { pushFollowers: true })
        .setTween(sbTimeline17)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene17)
    }

    /**
     * 1-18
     */
    if (this.$store.state.currentLocation === 18) {
      const sbTimeline18 = new TimelineMax()
        // .from('#sb-1-18>.panel__parallax', 1, { y: '20%' }, 'first', 'second')
        .from('#sb-1-18 p', 1, { alpha: 0 }, 0.5, 'first')
        // .staggerFrom('#sb-1-18 strong', 1, { color: '#5D6978' }, 0.5, 'second')
        // .staggerFrom('#sb-1-18 .patterned-list li', 1, { alpha: 0 }, 0.5, 'second')
        // .from('#sb-1-18-panel-01', 1, { x: '-25%', alpha: 0 }, 'third')
        // .from('#sb-1-18-panel-02', 1, { x: '25%', alpha: 0 }, 'third')
        .staggerFrom('#sb-1-18 .accordion', 1, { alpha: 0 }, 0.5, 'first')
        .from('#sb-1-18 button', 0, { alpha: 0, y: '20px' }, 'first')

      const sbScene18 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-18',
        triggerHook: '0.5',
        duration: 0
      })
        // // .setPin('#sb-1-18', { pushFollowers: true })
        .setTween(sbTimeline18)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene18)
    }

    /**
     * 1-19
     */
    if (this.$store.state.currentLocation === 19) {
      const sbTimeline19 = new TimelineMax()
        // .from('#sb-1-19>.panel__parallax', 1, { y: '20%' }, 'first', 'second')
        .staggerFrom('#sb-1-19 p', 1, { alpha: 0 }, 0.5, 'first')
        .staggerFrom('#sb-1-19 .patterned-list ul', 1, { alpha: 0 }, 0.5, 'second')
        .from('#sb-1-19 button', 0, { alpha: 0, y: '20px' }, 'third')

      const sbScene19 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-19',
        triggerHook: '0.5',
        duration: 0
      })
        // // .setPin('#sb-1-19', { pushFollowers: true })
        .setTween(sbTimeline19)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene19)
    }

    /**
     * 1-20
     */
    if (this.$store.state.currentLocation === 20) {
      const sbTimeline20 = new TimelineMax()
        .from('#sb-1-20>.panel__parallax', 1, { y: '20%' }, 'first')
        .staggerFrom('#sb-1-20 p', 1, { alpha: 0 }, 0.5, 'first')
        .from('#sb-1-20 button', 0, { alpha: 0, y: -20 })

      const sbScene20 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-20',
        triggerHook: '0.5',
        duration: 0
      })
        // .setPin('#sb-1-20', { pushFollowers: true })
        .setTween(sbTimeline20)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene20)
    }

    /**
     * 1-21
     */
    if (this.$store.state.currentLocation === 21) {
      const sbTimeline21 = new TimelineMax()
        .from('#sb-1-21>.panel__parallax', 1, { y: '20%' }, 'first')
        // .staggerFrom('#sb-1-21 p', 1, { y: '20%', alpha: 0 })
        .staggerFrom('#sb-1-21 p', 1, { alpha: 0 }, 0.5, 'first')
        .from('#sb-1-21 button', 0, { alpha: 0, y: -20 })
        // .staggerFrom('#sb-1-21 p', 0.3, { alpha: 0 }, 0.2, 'first')
        // .staggerFrom('#sb-1-21 li', 0.3, { alpha: 0 }, 0.2, 'second')

      const sbScene21 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-21',
        triggerHook: '0.5',
        duration: 0
      })
        // // .setPin('#sb-1-21', { pushFollowers: true })
        .setTween(sbTimeline21)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene21)
    }

    /**
     * 1-22
     */
    if (this.$store.state.currentLocation === 22) {
      const sbTimeline22 = new TimelineMax()
        .from('#sb-1-21>.panel__parallax', 1, { y: '20%' }, 'first', 'second')
        // .from('#sb-1-22 img', 0.5, { y: '-0%', alpha: 0 })
        .staggerFrom('#sb-1-22 p', 0.3, { alpha: 0 }, 0.2, 'first')
        .staggerFrom('#sb-1-19a-image', 0.3, { alpha: 0 }, 0.2, 'first')
        .from('#sb-1-21 button', 0, { alpha: 0, y: -20 }, 0.2, 'first')
        // .staggerFrom('#sb-1-22 li', 0.3, { alpha: 0 }, 0.2, 'second')

      const sbScene22 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-22',
        triggerHook: '0.5',
        duration: 0
      })
        // // .setPin('#sb-1-22', { pushFollowers: true })
        .setTween(sbTimeline22)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene22)
    }

    /**
     * 1-23
     */
    if (this.$store.state.currentLocation === 21) {
      const sbTimeline23 = new TimelineMax()
        .from('#sb-1-23 img', 0.5, { x: '-20%', alpha: 0 })
        .staggerFrom('#sb-1-23 li', 0.5, { alpha: 0 }, 0.5, 'first')
        // .staggerFrom('#sb-1-23 li', 0.3, { alpha: 0 }, 0.2, 'second')
        .from('#sb-1-23 button', 0, { alpha: 0, y: '20px' }, 'second')

      const sbScene23 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-23',
        triggerHook: '1',
        duration: 0
      })
        // // .setPin('#sb-1-23', { pushFollowers: true })
        .setTween(sbTimeline23)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene23)
    }

    /**
     * 1-24
     */
    if (this.$store.state.currentLocation === 24) {
      const sbTimeline24 = new TimelineMax()
        // .from('#sb-1-24 img', 0.5, { x: '-20%', alpha: 0 })
        .staggerFrom('#sb-1-24 p', 0.5, { alpha: 0 }, 0.5, 'first')
        .staggerFrom('#sb-1-24 strong', 0.5, { color: '#5D6978' }, 0.2, 'second')
        // .staggerFrom('#sb-1-24 li', 0.3, { alpha: 0 }, 0.2, 'second')
        .from('#sb-1-24 button', 0, { alpha: 0, y: '20px' }, 'second')

      const sbScene24 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-24',
        triggerHook: '0.5',
        duration: 0
      })
        // .setPin('#sb-1-24', { pushFollowers: true })
        .setTween(sbTimeline24)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene24)
    }

    // /**
    //  * 1-25
    //  */
    // if (this.$store.state.currentLocation >= 25) {
    // }

    // /**
    //  * 1-26
    //  */
    // if (this.$store.state.currentLocation >= 26) {
    //   const sbTimeline26 = new TimelineMax()
    //     // .from('#sb-1-26 img', 0.5, { x: '-20%', alpha: 0 })
    //     .staggerFrom('#sb-1-26 p', 0.3, { alpha: 0 }, 0.2, 'first')
    //     .staggerFrom('#sb-1-26 li', 0.3, { x: -29, alpha: 0 }, 0.2, 'second')
    //     // .staggerFrom('#sb-1-26 li', 0.3, { alpha: 0 }, 0.2, 'second')
    //     .from('#sb-1-26 button', 0, { alpha: 0, y: '20px' }, 'second')

    //   const sbScene26 = this.$scrollmagic.scene({
    //     triggerElement: '#sb-1-26',
    //     triggerHook: '1',
    //     duration: 0
    //   })
    //     // // .setPin('#sb-1-26', { pushFollowers: true })
    //     .setTween(sbTimeline26)
    //   // .addIndicators() // add indicators (requires plugin)
    //   this.$scrollmagic.addScene(sbScene26)
    // }

    // /**
    //  * 1-27
    //  */
    // if (this.$store.state.currentLocation >= 27) {
    // }

    /**
     * 1-25
     */
    if (this.$store.state.currentLocation === 25) {
      const sbTimeline25 = new TimelineMax()
        // .from('#sb-1-28>.panel__parallax', 1, { y: '20%' }, 'first')
        .set('#stigma-01 .stigma-wrong__text', { className: '-=stigma-wrong__text--strike' })
        .from('#stigma-01', 1, { alpha: 0, y: '20%' })
        .set('#stigma-01 .stigma-wrong__text', { className: '+=stigma-wrong__text--strike' })
        // .from('#stigma-01 .stigma__wrong-cross', 1, { width: '0%' })
        .from('#stigma-01 .stigma__right', 1, { alpha: 0, color: '#5D6978' })
        .from('#stigma-01 button', 0, { alpha: 0, y: '-20%' })

      const sbScene25 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-25',
        triggerHook: '0.5',
        duration: 0
      })
        .setTween(sbTimeline25)
        // .setClassToggle('#stigma-01 .stigma-wrong__text', 'stigma-wrong__text--strike') // add class toggle
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbScene25)
    }

    // STIGMA 2
    if (this.$store.state.currentLocation >= 25.1) {
      const sbTimelineStigma02 = new TimelineMax()
        // .from('#sb-1-28>.panel__parallax', 1, { y: '20%' }, 'first')
        .set('#stigma-02 .stigma-wrong__text', { className: '-=stigma-wrong__text--strike' })
        .from('#stigma-02', 1, { alpha: 0, y: '20%' })
        .set('#stigma-02 .stigma-wrong__text', { className: '+=stigma-wrong__text--strike' })
        // .staggerFrom('#stigma-02 .stigma__wrong-cross', 1, { width: '0%' })
        .from('#stigma-02 .stigma__right', 1, { alpha: 0, color: '#5D6978' })
        .from('#stigma-02 button', 0, { alpha: 0, y: '-20%' })

      const sbSceneStigma02 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-25',
        triggerHook: '0.5',
        duration: 0
      })
        .setTween(sbTimelineStigma02)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbSceneStigma02)
    }

    // STIGMA 3
    if (this.$store.state.currentLocation >= 25.2) {
      const sbTimelineStigma03 = new TimelineMax()
        // .from('#sb-1-28>.panel__parallax', 1, { y: '20%' }, 'first')
        .set('#stigma-03 .stigma-wrong__text', { className: '-=stigma-wrong__text--strike' })
        .from('#stigma-03', 1, { alpha: 0, y: '20%' })
        .set('#stigma-03 .stigma-wrong__text', { className: '+=stigma-wrong__text--strike' })
        // .from('#stigma-03 .stigma__wrong-cross', 1, { width: '0%' })
        .from('#stigma-03 .stigma__right', 1, { alpha: 0, color: '#5D6978' })
        .from('#stigma-03 button', 0, { alpha: 0, y: '-20%' })

      const sbSceneStigma03 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-25',
        triggerHook: '0.5',
        duration: 0
      })
        .setTween(sbTimelineStigma03)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbSceneStigma03)
    }

    // STIGMA 4
    if (this.$store.state.currentLocation >= 25.3) {
      const sbTimelineStigma04 = new TimelineMax()
        // .from('#sb-1-28>.panel__parallax', 1, { y: '20%' }, 'first')
        .set('#stigma-04 .stigma-wrong__text', { className: '-=stigma-wrong__text--strike' })
        .from('#stigma-04', 1, { alpha: 0, y: '20%' })
        .set('#stigma-04 .stigma-wrong__text', { className: '+=stigma-wrong__text--strike' })
        // .from('#stigma-04 .stigma__wrong-cross', 1, { width: '0%' })
        .from('#stigma-04 .stigma__right', 1, { alpha: 0, color: '#5D6978' })
        .from('#stigma-04 button', 0, { alpha: 0, y: '-20%' })

      const sbSceneStigma04 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-25',
        triggerHook: '0.5',
        duration: 0
      })
        .setTween(sbTimelineStigma04)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbSceneStigma04)
    }

    // STIGMA 5
    if (this.$store.state.currentLocation >= 25.4) {
      const sbTimelineStigma05 = new TimelineMax()
        // .from('#sb-1-28>.panel__parallax', 1, { y: '20%' }, 'first')
        .set('#stigma-05 .stigma-wrong__text', { className: '-=stigma-wrong__text--strike' })
        .from('#stigma-05', 1, { alpha: 0, y: '20%' })
        .set('#stigma-05 .stigma-wrong__text', { className: '+=stigma-wrong__text--strike' })
        // .from('#stigma-05 .stigma__wrong-cross', 1, { width: '0%' })
        .from('#stigma-05 .stigma__right', 1, { alpha: 0, color: '#5D6978' })
        .from('#stigma-05 button', 0, { alpha: 0, y: '-20%' })

      const sbSceneStigma05 = this.$scrollmagic.scene({
        triggerElement: '#sb-1-25',
        triggerHook: '0.5',
        duration: 0
      })
        .setTween(sbTimelineStigma05)
        // .addIndicators() // add indicators (requires plugin)
      this.$scrollmagic.addScene(sbSceneStigma05)
    }

    // // STIGMA 6
    // if (this.$store.state.currentLocation >= 28.5) {
    //   const sbTimelineStigma06 = new TimelineMax()
    //     // .from('#sb-1-28>.panel__parallax', 1, { y: '20%' }, 'first')
    //     .set('#stigma-06 .stigma-wrong__text', { className: '-=stigma-wrong__text--strike' })
    //     .from('#stigma-06', 1, { alpha: 0, y: '20%' })
    //     .set('#stigma-06 .stigma-wrong__text', { className: '+=stigma-wrong__text--strike' })
    //     // .from('#stigma-06 .stigma__wrong-cross', 1, { width: '0%' })
    //     .from('#stigma-06 .stigma__right', 1, { alpha: 0, color: '#5D6978' })
    //     .from('#stigma-06 button', 0, { alpha: 0, y: '-20%' })

    //   const sbSceneStigma06 = this.$scrollmagic.scene({
    //     triggerElement: '#sb-1-28',
    //     triggerHook: '0.5',
    //     duration: 0
    //   })
    //     .setTween(sbTimelineStigma06)
    //     // .addIndicators() // add indicators (requires plugin)
    //   this.$scrollmagic.addScene(sbSceneStigma06)
    // }

    // /**
    //  * 1-29
    //  */
    // if (this.$store.state.currentLocation >= 29) {
    //   const sbTimeline29 = new TimelineMax()
    //     .from('#sb-1-29 img', 0.5, { x: '-20%', alpha: 0 })
    //     .staggerFrom('#sb-1-29 p', 0.3, { alpha: 0 }, 0.2, 'first')
    //     // .staggerFrom('#sb-1-29 li', 0.3, { alpha: 0 }, 0.2, 'second')

    //   const sbScene29 = this.$scrollmagic.scene({
    //     triggerElement: '#sb-1-29',
    //     triggerHook: '0.5',
    //     duration: 0
    //   })
    //     // .setPin('#sb-1-29', { pushFollowers: true })
    //     .setTween(sbTimeline29)
    //     // .addIndicators() // add indicators (requires plugin)
    //   this.$scrollmagic.addScene(sbScene29)
    // }

    // /**
    //  * 1-30
    //  */
    // if (this.$store.state.currentLocation >= 30) {
    // }
  },
  methods: {
    replayVideo (e) {
      e.currentTarget.load()
    }
  },
  computed: {
    // return total quiz progress of (current store quizProgress / total number of questions) * 100
    getCourseProgress () {
      const progress = ((this.$store.state.currentLocation) / this.$store.state.totalPages) * 100
      return progress
    }
  },
  mounted () {
    // Fire init event
    this.$store.dispatch('initCourse')
    /**
     * IE FIX
     */
    if (navigator.userAgent.match(/Trident\/7\./)) { // if IE
      $('body').on('mousewheel', function () {
        // remove default behavior
        event.preventDefault()

        // scroll without smoothing
        var wheelDelta = event.wheelDelta
        var currentScrollPosition = window.pageYOffset
        window.scrollTo(0, currentScrollPosition - wheelDelta)
      })
    }
    /**
     * INTRO
     */
    const intro = this.$scrollmagic.scene({
      triggerElement: '#intro',
      triggerHook: 0,
      duration: '100%'
    })
      .setTween('#intro-parallax', { y: '20%' })
      // .addIndicators()
    this.$scrollmagic.addScene(intro)
  }
}
</script>

<style lang="scss">
/*------------------------------------*\
  #PRIMARY COLOURS
\*------------------------------------*/
@import '../styles/colors';

/*------------------------------------*\
  #Mixins
\*------------------------------------*/

/*------------------------------------
  #MEDIA SCREENS < 768px (#MOBILE FIRST)
\*------------------------------------*/

/*------------------------------------*\
  #MEDIA SCREENS > 767px (TABLETS)
\*------------------------------------*/
@media (min-width: 767px) {
}

/*------------------------------------*\
  #MEDIA SCREENS > 992px
  (LAPTOP, TABLET)
\*------------------------------------*/
@media (min-width: 992px) {
}

/*------------------------------------*\
  #MEDIA SCREENS > 1200px (DESKTOP)
\*------------------------------------*/
@media (min-width: 1200px) {
}

/*------------------------------------*\
  #MEDIA SCREENS > 1320px (DESKTOP)
\*------------------------------------*/
@media (min-width: 1320px) {
}

/*------------------------------------*\
  #MEDIA SCREENS > 1600px (DESKTOP)
\*------------------------------------*/
@media (min-width: 1600px) {
}
</style>
